module.exports = __webpack_public_path__ + "static/media/giftboxes.655f7522.svg";